import React, { useState } from "react";
import { Alert, TextField, Paper, Button, Divider, Typography } from "@mui/material";
import LoginIcon from "@mui/icons-material/Login";

import { useUserId } from "../hooks/useUserId";

export const Login: React.FC = () => {
  const { login, loginError, loginErrorMsg } = useUserId();
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = () => {
    if (name.trim() && password) {
      login(name.trim(), password);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-b from-emerald-900 to-emerald-950 p-4">
      <div className="text-center mb-8">
        <h1 className="text-5xl font-bold text-white mb-2">Königsrufen</h1>
        <p className="text-emerald-300 text-lg">Austrian Tarock Card Game</p>
      </div>

      <Paper elevation={6} className="p-8 max-w-md w-full rounded-xl">
        <div className="flex flex-col gap-4">
          <Typography variant="h6" className="text-center" color="textSecondary">
            Sign in to play
          </Typography>

          <TextField
            name="name"
            type="text"
            placeholder="Enter your name"
            label="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleLogin()}
            fullWidth
          />

          <TextField
            name="password"
            type="password"
            placeholder="Enter your password"
            label="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleLogin()}
            fullWidth
          />

          {loginError && (
            <Alert severity="error" sx={{ mt: 1 }}>
              {loginErrorMsg}
            </Alert>
          )}

          <Button
            variant="contained"
            size="large"
            onClick={handleLogin}
            disabled={!name.trim() || !password}
            startIcon={<LoginIcon />}
            sx={{
              py: 1.5,
              fontSize: "1.1rem",
              backgroundColor: "#059669",
              "&:hover": { backgroundColor: "#047857" },
              "&:disabled": { backgroundColor: "#6b7280" },
            }}
          >
            Login / Create Account
          </Button>

          <Divider sx={{ my: 1 }} />

          <Typography variant="body2" color="textSecondary" className="text-center">
            New here? Just pick a name and password to create your account.
          </Typography>
        </div>
      </Paper>

      <p className="text-emerald-400 text-sm mt-8 opacity-70">
        A four-player trick-taking game with Tarot cards
      </p>
    </div>
  );
};
